
/**
 * tag-list.js
 * 
 * Handle hide/show events on lists of tags. Mainly just expanding them.
 */
;(function($, window, document) {

  if ($('.tags')) {

    $('.tags button.more').on('click', function () {
      const tags = $(this).parent().parent();
      tags.find('.more').attr('aria-expanded', true);
      tags.addClass('show-hidden');

      tags.find('.tag').first().focus();

    });

  }
})(jQuery, window, document);
